import generateId from '../generateId';

export default class ElementBase {
  // @param type is a plannerComponentTypesEnum
  // @param @id is an identifier
  constructor(
    type,
    id = generateId(),
  ) {
    this.id = id;
    this.type = type;
  }
}
